/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-22T09:43:58.162
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listHouseLeaseContract,
	listHouseLeaseContractInit,
	listHouseLeaseContractByAuthorizations,
	deleteHouseLeaseContract
} from '@api/lcf/HouseLeaseContract';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listHouseLeaseContract({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseLeaseContract(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHouseLeaseContractByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseLeaseContractByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHouseLeaseContractInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseLeaseContractInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteHouseLeaseContract({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteHouseLeaseContract({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
